import { render, staticRenderFns } from "./DeleteAccountModal.vue?vue&type=template&id=574a5b54&"
import script from "./DeleteAccountModal.vue?vue&type=script&lang=js&"
export * from "./DeleteAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports